/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

export const LOADING = 'LOADING';
export const LOADED = 'LOADED';
export const EMPTY = 'EMPTY';
export const SAVING = 'SAVING';
export const SAVED = 'SAVED';
export const SAVING_ERROR = 'SAVING_ERROR';
export const SHOW_PREVIEW = 'SHOW_PREVIEW';
export const HIDE_PREVIEW = 'HIDE_PREVIEW';

export const SET_TITLE = 'SET_TITLE';
export const SET_WEIGHTED = 'SET_WEIGHTED';
export const SET_MID_RISK_THRESHOLD = 'SET_MID_RISK_THRESHOLD';
export const SET_HIGH_RISK_THRESHOLD = 'SET_HIGH_RISK_THRESHOLD';
export const ADD_QUESTION = 'ADD_QUESTION';
export const ADD_ANOTHER_QUESTION = 'ADD_ANOTHER_QUESTION';
export const EDIT_QUESTION = 'EDIT_QUESTION';
export const SET_QUESTIONS_ORDER = 'SET_QUESTIONS_ORDER';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const ADD_PAGE = 'ADD_PAGE';
export const REMOVE_PAGE = 'REMOVE_PAGE';

export const SET_QUESTION_TYPE = 'SET_QUESTION_TYPE';
export const SET_QUESTION_TITLE = 'SET_QUESTION_TITLE';
export const SET_QUESTION_DESCRIPTION = 'SET_QUESTION_DESCRIPTION';
export const SET_QUESTION_REQUIRED = 'SET_QUESTION_REQUIRED';
export const SET_QUESTION_WEIGHT = 'SET_QUESTION_WEIGHT';
export const SET_QUESTION_PAGE = 'SET_QUESTION_PAGE';
export const SET_QUESTION_OPTION_TITLE = 'SET_QUESTION_OPTION_TITLE';
export const SET_QUESTION_OPTION_MULTIPLIER = 'SET_QUESTION_OPTION_MULTIPLIER';
export const SET_QUESTION_MAPPINGS = 'SET_QUESTION_MAPPINGS';
export const ADD_QUESTION_OPTION = 'ADD_QUESTION_OPTION';
export const REMOVE_QUESTION_OPTION = 'REMOVE_QUESTION_OPTION';
export const ADD_QUESTION_OPTION_SUBQUESTION = 'ADD_QUESTION_OPTION_SUBQUESTION';
export const SET_QUESTION_OPTIONS_ORDER = 'SET_QUESTION_OPTIONS_ORDER';
export const ADD_QUESTION_CONDITION = 'ADD_QUESTION_CONDITION';
export const REMOVE_QUESTION_CONDITION = 'REMOVE_QUESTION_CONDITION';
export const SET_QUESTION_CONDITION_QUESTION = 'SET_QUESTION_CONDITION_QUESTION';
export const SET_QUESTION_CONDITION_OPTION = 'SET_QUESTION_CONDITION_OPTION';
export const SET_QUESTION_VISIBLE_ALWAYS = 'SET_QUESTION_VISIBLE_ALWAYS';
export const SET_QUESTION_VISIBLE_CONDITIONAL = 'SET_QUESTION_VISIBLE_CONDITIONAL';
export const REMOVE_QUESTION = 'REMOVE_QUESTION';
export const DUPLICATE_QUESTION = 'DUPLICATE_QUESTION';
